import { GroupChatFormFields } from "@/pages/Groupchat/types";

export const MINIMUM_PARTICIPANT_LIMIT = 2;
export const MINIMUM_PARTICIPANT_ERROR_MESSAGE = "At least 2 chatbots required";
export const MAXIMUM_PARTICIPANT_LIMIT = 10;

export const GROUPCHAT_FORM_FIELDS_PLACEHOLDER = {
  [GroupChatFormFields.GREETING]:
    "Ah, everyone, good. You’ve all made it here in one piece. If you’re ready to uncover what’s been hidden, gather around. The past has a habit of revealing itself when it chooses, though not every secret wants to be found. Still, if you’re willing to follow the clues, we might discover something memorable.",
  [GroupChatFormFields.NAME]: "Elara’s Expedition Team",
  [GroupChatFormFields.SCENARIO]:
    "The group finds itself in a dim stone chamber. A weathered map lies open on a table, lantern light flickering over faded symbols. Elara studies the ruins’ layout with sharp focus, her presence setting a tone of intrigue and quiet intensity.",
  [GroupChatFormFields.TITLE]:
    "A small team assembled by renowned archaeologist Elara Nightshade to investigate long-buried secrets. Expect cryptic hints, ancient maps, and a lot of dust.",
};

export const groupChatRequiredFields = [
  GroupChatFormFields.COVER,
  GroupChatFormFields.NAME,
  GroupChatFormFields.TITLE,
  GroupChatFormFields.GREETING,
  GroupChatFormFields.MEMBERS,
  GroupChatFormFields.GUIDELINES,
];
